(() => {
  const initHongKongPaymentCta = (scope = document) => {
    scope.querySelectorAll('[data-hk-payment-cta]:not([data-hk-payment-cta-initialized])').forEach((cta) => {
      cta.setAttribute('data-hk-payment-cta-initialized', 'true');

      const buttons = cta.closest('.product-form__buttons');
      const shell = cta.querySelector('[data-hk-payment-button-shell]');
      if (!buttons || !shell) return;

      const activate = () => {
        if (cta.hasAttribute('data-hk-payment-cta-ready')) return true;

        const nativeMoreOptions = buttons.querySelector(
          'a.shopify-payment-button__more-options:not(.shopify-payment-button__skeleton)'
        );
        if (!nativeMoreOptions) return false;

        shell.appendChild(nativeMoreOptions);
        shell.removeAttribute('aria-hidden');
        cta.setAttribute('data-hk-payment-cta-ready', 'true');
        cta.removeAttribute('hidden');
        return true;
      };

      if (activate()) return;

      const observer = new MutationObserver(() => {
        if (activate()) observer.disconnect();
      });

      observer.observe(buttons, { childList: true, subtree: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initHongKongPaymentCta());
  } else {
    initHongKongPaymentCta();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initHongKongPaymentCta(event.target);
  });
})();
